import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { Clock, MapPin, ArrowRight, ArrowLeft, Star } from "react-feather";
import Link from "next/link";

const CommentCarousel = ({ items }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToDisplay, setItemsToDisplay] = useState(3);
  const [hoveredIndex, setHoveredIndex] = useState(-1); // -1 means no card is hovered

  useEffect(() => {
    const handleResize = () => {
      setItemsToDisplay(
        window.innerWidth <= 768 ? 1 : window.innerWidth <= 1024 ? 2 : 3
      );
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  };

  return (
    <Container maxWidth={"lgs"} disableGutters={true} className="">
      <Box mt={2}>
        <Box width="100%">
          <Box position="relative">
            <Box
              className="p-[45px]"
              display="grid"
              gridTemplateColumns={`repeat(${itemsToDisplay}, 1fr)`}
              gap={4}
            >
              {items
                .slice(currentIndex, currentIndex + itemsToDisplay)
                .map((card, index) => (
                  <Box
                    key={card.id}
                    className="bg-[#fff] p-[20px] shadow-md cursor-pointer relative overflow-hidden"
                  >
                    <Box className="flex">
                      {[...Array(card.star)].map((_, starIndex) => (
                        <Star key={starIndex}  size={25} color="#b07f50" fill="#b07f50"/>
                      ))}
                    </Box>
                    <Box className="font-bold mt-[15px] text-[#545454]">
                      {card.title}
                    </Box>
                    <Box className="h-[115px] line-clamp-5">
                      <Typography variant="body2">{card.subTitle}</Typography>
                    </Box>
                    <Box className="font-bold mt-[10px]">{card.owner}</Box>
                  </Box>
                ))}
            </Box>
            <Box className="flex justify-between mt-4 relative bottom-[200px] cursor-pointer">
              <Box
                className="w-9 h-9 rounded-full bg-[#cba47e] flex justify-center items-center relative right-0"
                onClick={handlePrev}
              >
                <ArrowLeft size={18} color="#fff" />
              </Box>
              <Box
                className="w-9 h-9 rounded-full bg-[#cba47e] flex justify-center items-center relative left-0"
                onClick={handleNext}
              >
                <ArrowRight size={18} color="#fff" />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default CommentCarousel;
